var _path, _rect, _path2, _path3, _rect2, _rect3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiversificar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H84V84H0V0Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 80,
    height: 80,
    rx: 27,
    fill: "#00C574"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 28C28.134 28 25 31.134 25 35V55C25 58.866 28.134 62 32 62H53C56.866 62 60 58.866 60 55V35C60 31.134 56.866 28 53 28H32Z",
    fill: "#00C574",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23C28.134 23 25 26.134 25 30V50C25 53.866 28.134 57 32 57H53C56.866 57 60 53.866 60 50V30C60 26.134 56.866 23 53 23H32Z",
    fill: "#00C574",
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 41,
    width: 12,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 47,
    width: 12,
    height: 2,
    rx: 1,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 41.6667L49 43L53 39",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47.6667L49 49L53 45",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1598 34.9705V35.7029C43.1598 35.8669 43.022 36 42.8517 36H42.1998C42.0298 36 41.8919 35.8669 41.8919 35.7029V34.9428C40.9602 34.7483 40.2427 34.2045 40.0124 33.4437C39.9613 33.2746 40.0734 33.0985 40.2524 33.0651L41.1412 32.9006C41.2922 32.8727 41.4431 32.9581 41.4886 33.1C41.6511 33.6064 42.0858 33.8204 42.607 33.8204C43.1313 33.8204 43.4845 33.5726 43.4845 33.232C43.4845 32.9752 43.3028 32.8098 42.9409 32.7267L41.7296 32.4691C40.6331 32.2391 40.0899 31.6963 40.0899 30.8324C40.0899 29.8486 40.7949 29.1956 41.8919 29.0212V28.2971C41.8919 28.1331 42.0298 28 42.1998 28H42.8517C43.022 28 43.1598 28.1331 43.1598 28.2971V29.0491C44.0537 29.2419 44.6919 29.767 44.8937 30.5123C44.9404 30.6847 44.83 30.8618 44.6475 30.8919L43.8037 31.0312C43.6489 31.0569 43.4999 30.9637 43.4582 30.8177C43.321 30.3363 42.9121 30.1339 42.4541 30.1339C41.9874 30.1339 41.6628 30.3817 41.6628 30.7125C41.6628 30.9612 41.8157 31.1268 42.1302 31.191L43.3602 31.4576C44.4566 31.6963 45 32.258 45 33.1406C45 34.161 44.2375 34.814 43.1598 34.9705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiversificar);
export default __webpack_public_path__ + "static/media/diversificar.7ab238604c253f1444827dc154cb4c9f.svg";
export { ForwardRef as ReactComponent };